module.exports = __webpack_public_path__ + "static/media/eg.c7ff299a.svg";